"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cs", {
  enumerable: true,
  get: function () {
    return _cs.default;
  }
});
Object.defineProperty(exports, "de", {
  enumerable: true,
  get: function () {
    return _de.default;
  }
});
Object.defineProperty(exports, "en", {
  enumerable: true,
  get: function () {
    return _en.default;
  }
});
Object.defineProperty(exports, "es", {
  enumerable: true,
  get: function () {
    return _es.default;
  }
});
Object.defineProperty(exports, "fr", {
  enumerable: true,
  get: function () {
    return _fr.default;
  }
});
Object.defineProperty(exports, "gr", {
  enumerable: true,
  get: function () {
    return _gr.default;
  }
});
Object.defineProperty(exports, "hu", {
  enumerable: true,
  get: function () {
    return _hu.default;
  }
});
Object.defineProperty(exports, "it", {
  enumerable: true,
  get: function () {
    return _it.default;
  }
});
Object.defineProperty(exports, "ja", {
  enumerable: true,
  get: function () {
    return _ja.default;
  }
});
Object.defineProperty(exports, "nl", {
  enumerable: true,
  get: function () {
    return _nl.default;
  }
});
Object.defineProperty(exports, "pl", {
  enumerable: true,
  get: function () {
    return _pl.default;
  }
});
Object.defineProperty(exports, "pt", {
  enumerable: true,
  get: function () {
    return _pt.default;
  }
});
Object.defineProperty(exports, "ru", {
  enumerable: true,
  get: function () {
    return _ru.default;
  }
});
Object.defineProperty(exports, "tr", {
  enumerable: true,
  get: function () {
    return _tr.default;
  }
});
Object.defineProperty(exports, "uk", {
  enumerable: true,
  get: function () {
    return _uk.default;
  }
});
Object.defineProperty(exports, "zh_Hant", {
  enumerable: true,
  get: function () {
    return _zh_Hant.default;
  }
});

var _cs = _interopRequireDefault(require("./cs"));

var _de = _interopRequireDefault(require("./de"));

var _en = _interopRequireDefault(require("./en"));

var _es = _interopRequireDefault(require("./es"));

var _fr = _interopRequireDefault(require("./fr"));

var _gr = _interopRequireDefault(require("./gr"));

var _hu = _interopRequireDefault(require("./hu"));

var _it = _interopRequireDefault(require("./it"));

var _ja = _interopRequireDefault(require("./ja"));

var _nl = _interopRequireDefault(require("./nl"));

var _pl = _interopRequireDefault(require("./pl"));

var _pt = _interopRequireDefault(require("./pt"));

var _ru = _interopRequireDefault(require("./ru"));

var _tr = _interopRequireDefault(require("./tr"));

var _uk = _interopRequireDefault(require("./uk"));

var _zh_Hant = _interopRequireDefault(require("./zh_Hant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }